import { apiEndpoints } from "@/services/api/api";
import { LoaderFunction } from "react-router-dom";
import { lecturerManageCoursesLoaderDTO } from "../types/lecturerCreateCourseTypes";

export const lecturerCreateCourseLoader: LoaderFunction =
  async (): Promise<lecturerManageCoursesLoaderDTO> => {
    try {
      const [tags, categories] = await Promise.all([
        apiEndpoints.getTagsForFilter(),
        apiEndpoints.getCategoriesForFilter(),
      ]);
      if (!categories.success || !tags.success)
        throw new Error("Failed to load categories or tags");
      return {
        categories: categories.data,
        tags: tags.data,
      };
    } catch (error) {
      console.error("Error loading course data:", error);
      throw new Error("Failed to load course data");
    }
  };
